




































































import {Component, Vue} from 'vue-property-decorator';
import {Area, AutoGroup} from "@/types";
import {
    addAutoGroup,
    deleteAutoGroup,
    getAreaList,
    getAutoGroupList,
    searchByArea,
    searchByAutoGroup
} from "@/endpoints";
import Search from "../utility/Search.vue";
import {serializeForm} from "@/util";

//Vue.component("v-search", Search);
Vue.component("v-search", Search);

@Component
export default class AutoGroups extends Vue {

    SearchByAutoGroup = searchByAutoGroup;

    submitted: boolean = false;
    loadingAutoGroups: boolean = false;

    groupToBeDeleted: AutoGroup = null;

    availableAutoGroups: AutoGroup[] = [];

    addAutoGroupForm: {
        name: string;
    } = {
        name: ""
    };

    mounted() {
        this.refreshAutoGroupList();
    }

    onSearchAutoGroupInput(result) {
        this.refreshAutoGroupList(result ? result.id : null);
    }

    async refreshAutoGroupList(id?: number) {

        this.loadingAutoGroups = true;

        const params = new URLSearchParams();

        if(id) {
            params.append("id", `${id}`);
        }

        this.availableAutoGroups = await getAutoGroupList(params.toString());

        this.loadingAutoGroups = false;
    }

    onDeleteAutoGroupButtonClick(group: AutoGroup) {
        this.groupToBeDeleted = group;
        (this.$refs['delete-auto-group-modal'] as any).show();
    }

    async onConfirmDeleteAutoGroupButtonClick() {
        this.submitted = true;
        this.availableAutoGroups = await deleteAutoGroup(this.groupToBeDeleted.id);
        this.submitted = false;
        (this.$refs['delete-auto-group-modal'] as any).hide();
    }

    async onAddAutoGroupSubmitButtonClick() {
        this.submitted = true;

        const payload = JSON.stringify(serializeForm(this.$refs['add-auto-group-form'] as HTMLFormElement));

        try {
            await addAutoGroup(payload);

            (this.$refs['add-auto-group-modal'] as any).hide();

            this.refreshAutoGroupList();
        } catch (e) {
            console.error(e);
        } finally {
            this.submitted = false;
        }
    }

    onAddAutoGroupModalHidden() {
        this.addAutoGroupForm.name = "";
    }

    get isValidAutoGroupName() {
        return this.addAutoGroupForm.name.length > 0;
    }

}
